<template>
  <div>
    <v-toolbar dense flat>
      <v-app-bar-nav-icon @click="goHome">
        <v-icon>home</v-icon>
      </v-app-bar-nav-icon>

      <v-toolbar-title>Order</v-toolbar-title>

      <v-spacer></v-spacer>
      <v-btn
        color="teal"
        :fab="$vuetify.breakpoint.xsOnly"
        text
        small
        dark
        @click="handleShareOrderLink"
      >
        <span v-if="!$vuetify.breakpoint.xsOnly">Share Link</span>
        <v-icon v-else>mdi-share-variant</v-icon>
      </v-btn>
      <v-btn
        color="teal"
        :fab="$vuetify.breakpoint.xsOnly"
        text
        small
        dark
        @click="handleCopyOrderLink"
      >
        <span v-if="!$vuetify.breakpoint.xsOnly">Copy Order Link</span>
        <v-icon v-else>mdi-link</v-icon>
      </v-btn>
      <v-btn
        color="teal"
        :fab="$vuetify.breakpoint.xsOnly"
        v-if="checkRightStatus(72)"
        text
        small
        dark
        to="/order/create"
      >
        <span v-if="!$vuetify.breakpoint.xsOnly">New</span>
        <v-icon v-else>add</v-icon>
      </v-btn>
      <v-btn
        color="teal"
        :fab="$vuetify.breakpoint.xsOnly"
        v-if="checkRightStatus(72)"
        text
        small
        dark
        to="/order/list"
      >
        <span v-if="!$vuetify.breakpoint.xsOnly">List</span>
        <v-icon v-else>list</v-icon>
      </v-btn>
    </v-toolbar>
    <v-divider></v-divider>
    <router-view></router-view>

    <!-- The collection selector dialog -->
    <SelectCollectionDialog
      v-model="showCollectionDialog"
      :collections="Collections"
      @select="onCollectionSelected"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Hashids from "hashids";
import collectionService from "@/modules/Product/Collection/service.js";
import SelectCollectionDialog from "@/modules/Order/RemoteOrderView/components/SelectCollectionDialog.vue";

const hashids = new Hashids();

export default {
  name: "product",
  components: {
    SelectCollectionDialog,
  },
  data() {
    return {
      showCollectionDialog: false,
      selectedCollection: null,
      pendingAction: null,
      Collections: [],
    };
  },
  computed: {
    ...mapGetters("global", [
      "currentUser",
      "checkRightStatus",
      "currentBusiness",
    ]),
  },
  created() {
    if (
      this.currentBusiness?.metadata?.forceCollection &&
      !this.selectedCollection
    ) {
      this.getCollection();
    }
  },
  methods: {
    goHome() {
      if (this.$route.path !== "/order") {
        this.$router.push({ path: "/order" });
      }
    },
    getCollection() {
      return collectionService
        .getAll({
          remoteOrder: true,
        })
        .then((result) => {
          // console.log("this.Category", result);
          // this.Collections = result.data.sort((a, b) => {
          //   if (a.name < b.name) return -1; // `a` comes before `b`
          //   if (a.name > b.name) return 1; // `a` comes after `b`
          //   return 0; // Names are equal
          // });

          this.Collections = [
            { id: null, name: "Show All" },
            ...result.data.sort((a, b) => {
              if (a.name < b.name) return -1;
              if (a.name > b.name) return 1;
              return 0;
            }),
          ];

          // Set the first category as selected
          // this.selectedCategory =
          //   this.Categories.length > 0 ? this.Categories[0].id : null;
        })
        .catch((error) => {
          console.log("error getting collection", error);
        });
    },
    copyCode(code) {
      navigator.clipboard.writeText(code);
      this.selectedCollection = null;
      this.$swal
        .mixin({
          toast: true,
          position: "top-end",
          showConfirmButton: true,
          timer: 2000,
        })
        .fire({
          icon: "success",
          title: "Order Link is copied",
        });
    },

    // WRAPPER: handles forcing collection
    handleShareOrderLink() {
      if (
        this.currentBusiness?.metadata?.forceCollection &&
        !this.selectedCollection
      ) {
        this.pendingAction = "share";
        this.showCollectionDialog = true;
      } else {
        this.shareOrderLink();
      }
    },
    handleCopyOrderLink() {
      if (
        this.currentBusiness?.metadata?.forceCollection &&
        !this.selectedCollection
      ) {
        this.pendingAction = "copy";
        this.showCollectionDialog = true;
      } else {
        this.createOrderLink();
      }
    },

    // ACTUAL share / copy implementations
    createOrderLink() {
      const link = this.buildOrderLink();
      this.copyCode(link);
    },
    shareOrderLink() {
      const link = this.buildOrderLink();
      if (navigator.share) {
        navigator
          .share({
            title: `Order Link from ${this.currentBusiness.name}`,
            text: `Here is your order link from ${this.currentBusiness.name}:`,
            url: link,
          })
          .then(() => console.log("Successfully shared"))
          .catch((error) => {
            console.error("Share failed:", error);
            this.copyCode(link);
          });
        this.selectedCollection = null;
      } else {
        this.copyCode(link);
      }
    },

    // builds the link with collection if selected
    buildOrderLink() {
      const hashId = hashids.encode(this.currentBusiness.code);
      let baseUrl =
        process.env.NODE_ENV === "development"
          ? `http://localhost:8082/public/order/${hashId}`
          : `https://app.smplsale.com/public/order/${hashId}`;

      if (this.selectedCollection) {
        baseUrl += `?collectionId=${this.selectedCollection.id}`;
      }
      return baseUrl;
    },

    // collection selected handler
    onCollectionSelected(collection) {
      this.selectedCollection = collection;
      // console.log("Selected collection:", collection);

      if (this.pendingAction === "share") {
        this.pendingAction = null;
        this.shareOrderLink();
      } else if (this.pendingAction === "copy") {
        this.pendingAction = null;
        this.createOrderLink();
      }
    },
  },
};
</script>